import { createSimpleFunctional } from '@/util'

export const VCardImg = createSimpleFunctional('v-card-img')
